import React from 'react';
import {
  ChakraProvider,
  Box,
  theme,
  Image,
  Code,
  Link,
  useColorModeValue,
  Center,
  Heading,
  Text,
  List,
  ListIcon,
  ListItem,
  Tag,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import logo from './athene.svg';
import { motion } from 'framer-motion';

import authenticate from 'athena-protocol';
import iclogo from './iclogo.svg';
import { useMotionValue, useSpring } from 'framer-motion';
import { CheckIcon } from '@chakra-ui/icons';
function App() {
  return (
    <ChakraProvider theme={theme}>
      <Inner />
    </ChakraProvider>
  );
}
function Inner() {
  let [identity, setIdentity] = React.useState(false);

  const opacity = useSpring(0, { stiffness: 200, damping: 30 });

  const colorMode = useColorModeValue('light', 'dark');

  const auth = async () => {
    let identity = await authenticate.authenticate({
      host: 'https://t2o37-7qaaa-aaaam-aav7a-cai.raw.ic0.app',
      mode: colorMode, // or "light"
      restore: false, // restore session automatically without prompting user (if user is already logged)
    });
    setIdentity(identity);
  };
  return (
    <>
      <Image
        w="10vh"
        as={motion.img}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 1.0 }}
        src={logo}
        onClick={auth}
        draggable={false}
        alt="Athena Protocol"
        onMouseEnter={() => {
          opacity.set(1);
        }}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: '440px',
          left: '50vw',
          marginLeft: '-5vh',
          zIndex: 500,
        }}
      />
      <motion.div style={{ opacity }}>
        <Box textAlign="center" fontSize="xl">
          <Heading mt="10vh">Athena Protocol</Heading>
          <Text fontSize="12px" mb="3vh">
            SOVEREIGN WEB3 IDENTITY
          </Text>
          <Tag
            fontSize="12px"
            colorScheme={'pink'}
            bg="pink.800"
            color="pink.300"
          >
            STATUS: EXPERIMENTAL
          </Tag>
          <Box fontSize="13px" mb="24vh">
            <List spacing={3} mt="2">
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Deploy your own Identity Provider in 2min
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Share the same identity across your dapps
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Easy & fast for new users
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                No client installation required
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Private keys are stored in your browser's credentials system
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Great mobile experience.{' '}
                <Text as="span" color="gray.400">
                  Biometric authentication
                </Text>
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Uses the latest browser authentication features
              </ListItem>
              <ListItem>
                <ListIcon as={CheckIcon} color="green.500" />
                Open-source Apache 2.0 License{' '}
                <Link
                  href="https://github.com/infu/athena-protocol"
                  target="_blank"
                  color="blue.400"
                >
                  GitHub
                </Link>
              </ListItem>
            </List>
          </Box>
          <ColorModeSwitcher mt={5} />
          {identity ? (
            <Box mt="10" fontSize="12px">
              Your Principal:
              <br />
              {identity.getPrincipal().toText()}
            </Box>
          ) : null}
          <Box mt="6vh">
            <Center>
              <Image src={iclogo} alt="Internet Computer" w={100} />
            </Center>
            <Box fontSize="12px" mt="4">
              MADE BY VVV DAO{' '}
            </Box>
            <Box mt="2" fontSize="12px">
              FOR THE INTERNET COMPUTER
            </Box>
          </Box>
        </Box>
      </motion.div>
    </>
  );
}

export default App;
